import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import { httpOk, GET, POST, PUT } from 'helpers/api'
import { findKeyFromArrayByValue, returnSign, checkPermission } from "helpers/helpers"

function Index() {
	const { t } = useTranslation()

	/* «Ҳолати» filtri ILGARI BEZAK edi — backend uni o'qimasdi (2026-08-06 da
	   tuzatildi). Nomlari ham to'g'rilandi: bu yerda o'chirish YO'Q, arxivlash bor. */
	const statuses = [
		{ 'id': 1, 'name': t('active') },
		{ 'id': -1, 'name': t('in_archive') },
	]

	const counterparties = [
		{ 'id': "clients", 'name': t('clients') },
		{ 'id': "suppliers", 'name': t('suppliers') },
		{ 'id': "employee", 'name': t('employees') },
	]

	// ── CHIQIM GURUHLARI (2026-08-06) ────────────────────────────────────────
	// Ro'yxat endi KODDA EMAS — «Созламалар → Чиқим гуруҳлари» dan keladi,
	// har tenant o'zi boshqaradi (qo'shadi / nomini / tartibini o'zgartiradi).
	const [plGroups, setPlGroups] = useState([])

	// Foydaga ta'siri. «Даромад» moddasida «айирилади» bo'lmaydi va aksincha —
	// shuning uchun ro'yxat `transaction_type` ga qarab qisqaradi.
	function effectOptions(transactionType) {
		return transactionType === 'plus'
			? [
				{ 'id': 'income', 'name': t('pl_effect_income') },
				{ 'id': 'neutral', 'name': t('pl_effect_neutral') },
			]
			: [
				{ 'id': 'expense', 'name': t('pl_effect_expense') },
				{ 'id': 'neutral', 'name': t('pl_effect_neutral') },
			]
	}

	/**
	 * Guruh nishoni rangi — guruh `id` si bo'yicha doimiy tanlanadi
	 * (ro'yxat oldindan noma'lum, tenant o'zi yaratadi).
	 * ⚠️ Bootstrap 5.2.3 — `bg-*-subtle` klasslari YO'Q (5.3 da qo'shilgan),
	 *    shuning uchun ranglar inline beriladi.
	 */
	const PALETTE = [
		{ background: '#e8effc', color: '#2456a6' },
		{ background: '#f0eafc', color: '#5b34a8' },
		{ background: '#e4f4f4', color: '#12706e' },
		{ background: '#fdefe3', color: '#a35a12' },
		{ background: '#fdeaea', color: '#a32d2d' },
		{ background: '#e8f5ec', color: '#1c7340' },
		{ background: '#eef0f3', color: '#5d6674' },
		{ background: '#f2f3f5', color: '#7b8494' },
	]
	function plBadgeStyle(groupId) {
		return PALETTE[Number(groupId) % PALETTE.length] || PALETTE[6]
	}

	/** Guruh tanlanganda ta'sir avtomat to'ldiriladi — har safar so'ralmasin */
	function onGroupChange(groupId) {
		const g = plGroups.find(x => x.id === groupId)
		let effect = g ? g.default_effect : null
		// Kirim moddasida «айирилади» bo'lmaydi — «тегмайди» ga tushiramiz
		if (selectedItem.transaction_type === 'plus' && effect === 'expense') effect = 'neutral'
		setSelectedItem({ ...selectedItem, 'pl_group_id': groupId ?? null, 'pl_effect': effect })
	}

	async function getPlGroups() {
		const response = await GET('/payment-purpose-groups', {}, { loader: false })
		if (httpOk(response)) setPlGroups(response.data)
	}

	const [data, setData] = useState([])
	const [accounts, setAccounts] = useState([])

	/* ── KO'PPASINI BIRDAN BELGILASH (2026-08-06) ────────────────────────────
	   Guruh birinchi marta joriy qilinganda hamma modda «Тасниф қилинмаган»
	   bo'ladi (bu tenantda 131 ta). Bittalab bosish real emas edi.
	   ⚠️ Dastur guruhni O'ZI TAXMIN QILMAYDI — user qarori: qo'lda, lekin tez. */
	const [selected, setSelected] = useState([])
	const [bulkGroup, setBulkGroup] = useState(null)
	// Ro'yxatni guruh bo'yicha filtrlash. '__none__' = tasniflanmaganlar.
	const [groupFilter, setGroupFilter] = useState(null)

	/** Ekranda ko'rinayotgan moddalar (guruh filtri qo'llangan) */
	function visibleRows() {
		if (!groupFilter) return data
		if (groupFilter === '__none__') return data.filter(x => !x.pl_group_id)
		return data.filter(x => Number(x.pl_group_id) === Number(groupFilter))
	}

	const shown = visibleRows()
	const allShownSelected = shown.length > 0 && shown.every(x => selected.includes(x.id))

	function toggleOne(id) {
		setSelected(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id])
	}
	function toggleAllShown() {
		if (allShownSelected) {
			const ids = shown.map(x => x.id)
			setSelected(p => p.filter(x => !ids.includes(x)))
		} else {
			setSelected(p => [...new Set([...p, ...shown.map(x => x.id)])])
		}
	}

	async function applyBulkGroup(groupId) {
		if (!selected.length) return
		const response = await PUT('/payment-purposes/bulk-group',
			{ ids: selected, pl_group_id: groupId }, { loader: true })
		if (httpOk(response)) {
			setSelected([])
			setBulkGroup(null)
			searchWithFilter()
		}
	}

	/**
	 * ARXIVLASH — o'chirish EMAS.
	 * Modda kassirning tanlash ro'yxatidan yo'qoladi, lekin hisobotlarda
	 * o'z joyida qoladi (eski chiqimlar unga bog'langan).
	 * Kerak bo'lganda «Архивдан» filtridan topib qayta tiklanadi.
	 */
	async function applyBulkStatus(status) {
		if (!selected.length) return
		const response = await PUT('/payment-purposes/bulk-status',
			{ ids: selected, status }, { loader: true })
		if (httpOk(response)) {
			setSelected([])
			searchWithFilter()
		}
	}

	/** Bitta modda — ⋮ menyusidan */
	async function applyRowStatus(id, status) {
		const response = await PUT('/payment-purposes/bulk-status',
			{ ids: [id], status }, { loader: true })
		if (httpOk(response)) searchWithFilter()
	}
	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({ 'transaction_type': 'minus' })

	/* TELEGRAM maydoni ko'rinsinmi (2026-08-13).
	   Modal ostidagi matn aniq va'da beradi: «Chiqim qayd etilganda shu chat
	   IDga bildirishnoma yuboriladi». Lekin `sec.telegram_settings` yo'q
	   tenantда bot tokenini qo'yadigan YAGONA sahifa ham yopiq — ya'ni
	   foydalanuvchi ID kiritadi, saqlanadi, bildirishnoma esa HECH QACHON
	   kelmaydi va xato ham chiqmaydi (TelegramService tokensiz jimgina
	   qaytadi). Bajarilmaydigan va'da — shuning uchun yashiriladi. */
	const canTg = checkPermission('sec.telegram_settings')
	const [filterData, setFilterData] = useState({ 'status': 1 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/payment-purposes', selectedItem, { loader: true })
		} else {
			response = await POST('/payment-purposes', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
			setSelectedItem({})
		}
	}

	async function searchWithFilter() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/payment-purposes"
		var urlParams = ""

		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
		}

		setDropdownIsOpen(false)
	}

	function toggleModal(bool = false, item = { 'transaction_type': 'minus' }) {
		setShowModal(bool)
		setSelectedItem(item)

		if (bool) {
			if (!accounts.length) getAccounts()
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	function returnEntityType(item) {
		var name = t('no')
		if (item?.counterparty === 'suppliers') {
			name = t('supplier')
		}
		if (item?.counterparty === 'employee' || item?.counterparty === 'employee_salary') {
			name = t('employee')
		}
		if (item?.counterparty === 'agent') {
			name = t('agent')
		}
		if (item?.counterparty === 'organization') {
			name = t('organization')
		}
		if (item?.counterparty === 'clients') {
			name = t('client')
		}

		return name
	}

	useEffect(() => {
		searchWithFilter()
		getPlGroups()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('income_expense')} [{data.length}]
				</h4>
				<div className="d-flex gap-2">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
					</div>

					<div className="filter-block">
						<div className="filter">
							<strong>{t('filter')}</strong>
							<br />
							{filterData.search &&
								<span className="me-2">
									<b>{t('search')}: </b>
									<span>{filterData.search}</span>
								</span>
							}
							{filterData.status &&
								<span className="me-2">
									<b>{t('status')}: </b>
									{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
								</span>
							}
						</div>
					</div>

					{/* Guruh bo'yicha tez o'tish — «Тасниф қилинмаган» ni bosib,
					    qolganini bir yo'la belgilab chiqiladi */}
					<div className="d-flex flex-wrap gap-2 mb-3">
						<button className={'btn btn-sm ' + (!groupFilter ? 'btn-primary' : 'btn-outline-secondary')}
							onClick={() => { setGroupFilter(null); setSelected([]) }}>
							{t('all')} <span className="ms-1 opacity-75">{data.length}</span>
						</button>
						<button className={'btn btn-sm ' + (groupFilter === '__none__' ? 'btn-danger' : 'btn-outline-danger')}
							onClick={() => { setGroupFilter('__none__'); setSelected([]) }}>
							{t('pl_unclassified')}
							<span className="ms-1 opacity-75">{data.filter(x => !x.pl_group_id).length}</span>
						</button>
						{plGroups.map(g => {
							const n = data.filter(x => Number(x.pl_group_id) === Number(g.id)).length
							if (!n) return null
							return (
								<button key={g.id}
									className={'btn btn-sm ' + (Number(groupFilter) === Number(g.id) ? 'btn-primary' : 'btn-outline-primary')}
									onClick={() => { setGroupFilter(g.id); setSelected([]) }}>
									{g.name} <span className="ms-1 opacity-75">{n}</span>
								</button>
							)
						})}
					</div>

					{/* Tanlanganlar paneli — faqat biror narsa tanlanganda ko'rinadi */}
					{selected.length > 0 &&
						<div className="d-flex flex-wrap align-items-center gap-2 mb-3 p-2"
							style={{ background: '#faf7ff', border: '1px solid #e3d9f7', borderRadius: '8px' }}>
							<b>{selected.length}</b> {t('selected')}
							<div style={{ minWidth: '260px' }}>
								<Select
									options={plGroups}
									value={plGroups.find(o => o.id === bulkGroup) || null}
									onChange={(option) => setBulkGroup(option?.id ?? null)}
									placeholder={t('pl_group')}
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<button className="btn btn-primary btn-sm" disabled={!bulkGroup}
								onClick={() => applyBulkGroup(bulkGroup)}>
								{t('save')}
							</button>
							<button className="btn btn-outline-danger btn-sm"
								onClick={() => applyBulkGroup(null)}>
								{t('pl_unclassified')}
							</button>

							<span className="text-muted mx-1">|</span>

							{/* Arxivlash — o'chirish EMAS. Modda kassir ro'yxatidan
							    yo'qoladi, hisobotlarda qoladi. */}
							{filterData.status !== -1
								? <button className="btn btn-outline-dark btn-sm"
									title={t('archive_hint')}
									onClick={() => applyBulkStatus(-1)}>
									<i className="uil-archive me-1" />{t('archive')}
								</button>
								: <button className="btn btn-outline-success btn-sm"
									onClick={() => applyBulkStatus(1)}>
									<i className="uil-history me-1" />{t('restore')}
								</button>}

							<button className="btn btn-outline-secondary btn-sm ms-auto"
								onClick={() => { setSelected([]); setBulkGroup(null) }}>
								{t('cancel')}
							</button>
						</div>}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '36px' }} className="text-center">
										<input type="checkbox" className="form-check-input m-0"
											checked={allShownSelected}
											onChange={toggleAllShown} />
									</th>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '22%' }}>{t('name2')}</th>
									<th style={{ 'width': '18%' }}>{t('pl_group')}</th>
									<th style={{ 'width': '15%' }}>{t('operation_account')}</th>
									<th style={{ 'width': '10%' }}>{t('type')}</th>
									<th style={{ 'width': '10%' }}>{t('counterparty')}</th>
									{canTg && <th style={{ 'width': '20%' }}>Telegram Chat ID</th>}
									<th style={{ 'width': '10%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{shown.length === 0 &&
									<tr><td colSpan="10" className="text-center text-muted py-4">{t('list_empty')}</td></tr>}
								{shown.map((item, index) => (
									<tr key={item.id}
										className={selected.includes(item.id) ? 'table-active' : ''}>
										<td className="text-center">
											<input type="checkbox" className="form-check-input m-0"
												checked={selected.includes(item.id)}
												onChange={() => toggleOne(item.id)} />
										</td>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis cursor" title={item.name}
											onClick={() => toggleOne(item.id)}>
											{item.name}
											{Number(item.status) < 0 &&
												<span className="badge ms-2"
													style={{ background: '#eef0f3', color: '#5d6674' }}>
													<i className="uil-archive me-1" />{t('in_archive')}
												</span>}
										</td>
										{/* Tasniflanmagan modda YASHIRILMAYDI — qizil bo'lib ko'zga tashlanadi */}
										<td>
											{item.pl_group_id
												? <span className="badge" style={plBadgeStyle(item.pl_group_id)}>
													{item.pl_group_name}
												</span>
												: <span className="badge"
													style={{ background: '#fff2f2', color: '#c22a2a', border: '1px dashed #f0a9a9' }}>
													{t('pl_unclassified')}
												</span>
											}
										</td>
										<td className="td-ellipsis" title={item.account_name}>{item.account_name}</td>
										<td>
											{item.transaction_type === 'minus' &&
												<span>{t('expense')}</span>
											}
											{item.transaction_type === 'plus' &&
												<span>{t('income')}</span>
											}
										</td>
										<td>{returnEntityType(item)}</td>
										{canTg &&
											<td>
												{item.telegram_chat_id
													? <span className="text-success"><i className="uil uil-telegram me-1"></i>{item.telegram_chat_id}</span>
													: <span className="text-muted">—</span>
												}
											</td>}
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														{/* Arxivlash SHU YERDA ham bo'lishi kerak — foydalanuvchi
														    uni avval ⋮ menyudan qidiradi, galochkali paneldan emas.
														    ⚠️ O'chirish YO'Q: eski chiqimlar moddaga bog'langan. */}
														{Number(item.status) < 0
															? <div className="table-dropdown-item text-success"
																onClick={() => applyRowStatus(item.id, 1)}>
																<i className="uil-history"></i>
																{t('restore')}
															</div>
															: <div className="table-dropdown-item"
																title={t('archive_hint')}
																onClick={() => applyRowStatus(item.id, -1)}>
																<i className="uil-archive"></i>
																{t('archive')}
															</div>}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name" value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('type')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'minus' })}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'minus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'minus' })}>
											{t('expense')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'plus' })}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'plus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'plus' })}>
											{t('income')}
										</span>
									</div>
								</div>
							</div>
						</div>
						{/* ── CHIQIM GURUHI ──────────────────────────────────────
						    Guruh tanlanganda «фойдага таъсири» AVTOMAT to'ladi;
						    foydalanuvchi faqat istisno holatda o'zgartiradi
						    (masalan: berilgan qarz — Инвестицион, lekin xarajat emas). */}
						<div className="form-group">
							<label>{t('pl_group')}</label>
							<Select
								isClearable
								options={plGroups}
								value={plGroups.find(option => option.id === selectedItem.pl_group_id) || null}
								onChange={(option) => onGroupChange(option?.id ?? null)}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
							{!selectedItem.pl_group_id &&
								<div className="text-muted mt-1" style={{ fontSize: '12px' }}>
									{t('pl_group_hint')}
								</div>}
						</div>

						{selectedItem.pl_group_id &&
							<div className="form-group">
								<label>{t('pl_effect')}</label>
								<Select
									options={effectOptions(selectedItem.transaction_type)}
									value={effectOptions(selectedItem.transaction_type)
										.find(option => option.id === selectedItem.pl_effect) || null}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'pl_effect': option?.id })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
								{selectedItem.pl_effect === 'neutral' &&
									<div className="mt-1 p-2" style={{
										fontSize: '12px', color: '#a3620a',
										background: '#fff8ec', border: '1px solid #f5e2c4', borderRadius: '6px'
									}}>
										{t('pl_effect_neutral_hint')}
									</div>}
							</div>}

						<div className="form-group">
							<label>{t('operation_account')}</label>
							<Select
								isClearable
								options={accounts}
								value={accounts.find(option => option.id === selectedItem.account_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'account_id': option?.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('report_account')}</label>
							<Select
								isClearable
								options={counterparties}
								value={counterparties.find(option => option.id === selectedItem.counterparty)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'counterparty': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						{canTg &&
							<div className="form-group">
								<label>Telegram Chat ID</label>
								<input type="text" className="form-control" name="telegram_chat_id"
									value={selectedItem.telegram_chat_id ?? ''}
									placeholder="Masalan: 1058156341"
									onChange={(e) => setSelectedItem({ ...selectedItem, 'telegram_chat_id': e.target.value || null })} />
								<small className="text-muted">Chiqim qayd etilganda shu chat IDga bildirishnoma yuboriladi</small>
							</div>}
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

		</>
	)
}

export default Index